import request from '../../utils/request';
import type { AppUser, UserFeatures } from '@/types';

export interface WorkspaceLoginPayload {
  accesstoken: string;
}

export interface AdminLoginPayload {
  username: string;
  password: string;
}



/** Fetch current authenticated user and available features. */
export function fetchAuthMe(): Promise<AppUser> {
  return request.get('/api/auth/me').then((res) => res.data);
}

/** D365 workspace token login. */
export function workspaceLogin(payload: WorkspaceLoginPayload): Promise<{ success: boolean; error?: string }> {
  return request.post('/api/auth/workspace-login', payload).then((res) => res.data);
}

/** Admin username/password login. */
export function adminLogin(payload: AdminLoginPayload): Promise<{ success: boolean; error?: string }> {
  return request.post('/auth/login', payload).then((res) => res.data);
}

/** Logout — clear the server session. */
export function logout(): Promise<void> {
  return request.post('/auth/logout');
}
